<template>
  <div style="width: 100%;min-height: 100%;background:#f3f3f3;position:absolute;">
    <div class="mainCtn">
      <div class="title">
        <div @click="$router.push('/MyRSservices')" style="position:absolute;top:0px;left:0px;width: 200px;height:45px;line-height: 45px;font-size: 16px;color: #3A3A3A;cursor:pointer;font-weight: normal;text-align: left;">
          <span style="font-size: 18px;">＜</span> &nbsp;返回我的套件
        </div>
        标准版套件订单详情
      </div>
      <div style="width: 100%;height: auto;">
        <div class="progressBarCtn">
          <div class="progressBar">
            <!--圆1-->
            <div class="progressCircle_gray">
              <span>1</span>
              <div v-if="1 <= progressStat" class="progressCircle_blue">
                1
              </div>
              <!--下方状态字-->
              <div class="progressCircle_Text">
                <div class="progressCircle_Text_name">
                  需求确认
                </div>
              </div>
            </div>
            <!--线1-->
            <div class="progressLine_gray">
              <div v-if="1 < progressStat" class="progressLine_blue">
              </div>
            </div>
            <!--圆2-->
            <div class="progressCircle_gray">
              <span>2</span>
              <div v-if="2 <= progressStat" class="progressCircle_blue">
                2
              </div>
              <!--下方状态字-->
              <div class="progressCircle_Text">
                <div class="progressCircle_Text_name">
                  订单提交
                </div>
                <div class="progressCircle_Text_time">
                  {{orderDetail.createTime}}
                </div>
              </div>
            </div>
            <!--线2-->
            <div class="progressLine_gray">
              <div v-if="2 < progressStat" class="progressLine_blue">
              </div>
            </div>
            <!--圆3-->
            <div class="progressCircle_gray">
              <span>3</span>
              <div v-if="progressStat>=3&&orderDetail.status!='已驳回'&&orderDetail.status!='已取消'" class="progressCircle_blue">
                3
              </div>
              <!--当步骤大于3（已交付），且未付款-->
              <div v-if="progressStat>3&&orderDetail.payStatus!='已付款'" class="progressCircle_red">
                3
              </div>
              <!--当步骤等于3，但已被驳回或取消-->
              <div v-if="progressStat==3&&(orderDetail.status=='已驳回'||orderDetail.status=='已取消')" class="progressCircle_red">
                3
              </div>
              <!--下方状态字-->
              <div class="progressCircle_Text">
                <div  class="progressCircle_Text_name">
                  <span v-if="progressStat<3" style="color:#B8B8B8">
                      审核与支付
                  </span>
                  <span v-if="progressStat==3">
                    <span v-if="orderDetail.status=='已驳回'">审核未通过</span>
                    <span v-if="orderDetail.status=='已取消'">已取消</span>
                    <span v-if="orderDetail.status=='待确认'">合同待确认</span>
                    <span v-if="orderDetail.status=='已确认'&&orderDetail.payStatus=='未付款'">合同已确认</span>
                    <span v-if="orderDetail.status=='已确认'&&orderDetail.payStatus=='已付款'">已付款</span>
                  </span>
                  <span v-if="progressStat>3">
                    <span v-if="orderDetail.payStatus=='未付款'">
                      未付款
                    </span>
                    <span v-if="orderDetail.payStatus=='已付款'">
                      已付款
                    </span>
                  </span>
                </div>
                <!--时间-->
                <div v-if="progressStat>=3" class="progressCircle_Text_time">
                  <span v-if="progressStat==3">
                    <span v-if="orderDetail.status=='已驳回'">{{ orderDetail.contractConfirmTime }}</span>
                    <span v-if="orderDetail.status=='已取消'"></span>
                    <span v-if="orderDetail.status=='待确认'"></span>
                    <span v-if="orderDetail.status=='已确认'&&orderDetail.payStatus=='未付款'">{{ orderDetail.contractConfirmTime }}</span>
                    <span v-if="orderDetail.status=='已确认'&&orderDetail.payStatus=='已付款'">{{ orderDetail.payTime }}</span>
                  </span>
                  <span v-if="progressStat>3">
                    <span v-if="orderDetail.payStatus=='未付款'">
                    </span>
                    <span v-if="orderDetail.payStatus=='已付款'">
                      {{ orderDetail.payTime }}
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <!--线3-->
            <div class="progressLine_gray">
              <div v-if="3 < progressStat" class="progressLine_blue">
              </div>
            </div>
            <!--圆4-->
            <div class="progressCircle_gray">
              <span>4</span>
              <div v-if="4 <= progressStat" class="progressCircle_blue">
                4
              </div>
              <!--下方状态字-->
              <div class="progressCircle_Text">
                <div class="progressCircle_Text_name">
                  <span v-if="progressStat<4" style="color:#B8B8B8">
                    交付
                  </span>
                  <span v-else>
                    已交付
                  </span>
                </div>
                <!--已交付未下载-->
                <div  class="progressCircle_Text_time">
                  {{orderDetail.postTime}}
                </div>
              </div>
            </div>
            <!--线4-->
            <div class="progressLine_gray">
              <div v-if="4 < progressStat" class="progressLine_blue">
              </div>
            </div>
            <!--圆5-->
            <div class="progressCircle_gray">
              <span>5</span>
              <div v-if="5 <= progressStat" class="progressCircle_blue">
                5
              </div>
              <!--下方状态字-->
              <div class="progressCircle_Text">
                <div class="progressCircle_Text_name">
                  <span v-if="progressStat<5" style="color:#B8B8B8">
                    评价
                  </span>
                  <span v-else>
                    已评价
                  </span>
                </div>
                <div class="progressCircle_Text_time">
                  <span v-if="progressStat==5">
                    {{orderDetail.evaluateTime}}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="orderDetailCtn" v-if="evaluationSuccess == 0">
        <div class="orderAppraiseTitle">
          订单评价
        </div>
        <!--已评价-->
        <div style="padding-top: 30px;padding-left:25px;padding-bottom: 70px" v-if="!isNotAlreadEvaluate">
          <div style="width: 100%;">
            <div class="left-des" style="font-weight: 600;color: #1D1D28;">总体满意度</div>
            <div class="right-content">
              <v-rating
                  style="margin-left:5px"
                  dense
                  v-model="rating"
                  background-color="2px solid #979797"
                  color="#336699"
                  hover
                  length="5"
                  size="25"
                  readonly
              ></v-rating>
            </div>
          </div>
          <div style="width: 100%;margin-top:11px">
            <div class="left-des">数据产品质量</div>
            <div class="right-content">
              <label class="input-label-first"><input disabled="disabled" class="input-radio" type="radio" value="满意"
                                                      v-model="productQuality">
                <p><span></span></p><span class="input-text">满意</span></label>
              <label class="input-label-other"><input disabled="disabled" class="input-radio" type="radio" value="一般"
                                                      v-model="productQuality">
                <p><span></span></p><span class="input-text">一般</span></label>
              <label class="input-label-other"><input disabled="disabled" class="input-radio" type="radio" value="不满意"
                                                      v-model="productQuality">
                <p><span></span></p><span class="input-text">不满意</span></label>
            </div>
          </div>
          <div style="width: 100%;margin-top:10px">
            <div class="left-des">交付时效</div>
            <div class="right-content">
              <label class="input-label-first"><input disabled="disabled" class="input-radio" type="radio" value="满意"
                                                      v-model="deliveryTime">
                <p><span></span></p><span class="input-text">满意</span></label>
              <label class="input-label-other"><input disabled="disabled" class="input-radio" type="radio" value="一般"
                                                      v-model="deliveryTime">
                <p><span></span></p><span class="input-text">一般</span></label>
              <label class="input-label-other"><input disabled="disabled" class="input-radio" type="radio" value="不满意"
                                                      v-model="deliveryTime">
                <p><span></span></p><span class="input-text">不满意</span></label>
            </div>
          </div>
          <div style="width: 100%;margin-top:10px">
            <div class="left-des">商务经理服务</div>
            <div class="right-content">
              <label class="input-label-first"><input disabled="disabled" class="input-radio" type="radio" value="满意"
                                                      v-model="managerService">
                <p><span></span></p><span class="input-text">满意</span></label>
              <label class="input-label-other"><input disabled="disabled" class="input-radio" type="radio" value="一般"
                                                      v-model="managerService">
                <p><span></span></p><span class="input-text">一般</span></label>
              <label class="input-label-other"><input disabled="disabled" class="input-radio" type="radio" value="不满意"
                                                      v-model="managerService">
                <p><span></span></p><span class="input-text">不满意</span></label>
            </div>
          </div>
          <div style="width: 100%;margin-top:25px">
            <div class="left-des"><span style="font-weight: 600;color: #1D1D28;">我想说</span>(选填)</div>
            <div style="float:right;width:70px;right:36px;position: relative;">
              {{textareaValue.length}}/200
            </div>
          </div>
          <div style="width: 92%;margin-top:6px;margin-left:37px">
            <v-textarea
                solo
                background-color="#F5F5F6"
                v-model="textareaValue"
                label="请告诉我们您最真实的想法…"
                :maxlength="200"
                disabled
            ></v-textarea>
          </div>
          <div style="float:right;width:70px;right:45px;position: relative;margin-top:-20px">
            <input class='input-check' type="checkbox" value="0" v-model="isAnonymous" disabled="disabled"><span
              class='input-span'>匿名</span>
          </div>
        </div>
        <!--未评价-->
        <div style="padding-top: 30px;padding-left:25px;padding-bottom: 70px" v-if="isNotAlreadEvaluate">
          <div style="width: 100%;">
            <div class="left-des" style="font-weight: 600;color: #1D1D28;">总体满意度</div>
            <div class="right-content">
              <v-rating
                  style="margin-left:5px"
                  dense
                  v-model="rating"
                  background-color="2px solid #979797"
                  color="#336699"
                  hover
                  length="5"
                  size="25"
              ></v-rating>
            </div>
          </div>
          <div style="width: 100%;margin-top:11px">
            <div class="left-des">数据产品质量</div>
            <div class="right-content">
              <label class="input-label-first"><input class="input-radio" type="radio" value="满意"
                                                      v-model="productQuality">
                <p><span></span></p><span class="input-text">满意</span></label>
              <label class="input-label-other"><input class="input-radio" type="radio" value="一般"
                                                      v-model="productQuality">
                <p><span></span></p><span class="input-text">一般</span></label>
              <label class="input-label-other"><input class="input-radio" type="radio" value="不满意"
                                                      v-model="productQuality">
                <p><span></span></p><span class="input-text">不满意</span></label>
            </div>
          </div>
          <div style="width: 100%;margin-top:10px">
            <div class="left-des">交付时效</div>
            <div class="right-content">
              <label class="input-label-first"><input class="input-radio" type="radio" value="满意"
                                                      v-model="deliveryTime">
                <p><span></span></p><span class="input-text">满意</span></label>
              <label class="input-label-other"><input class="input-radio" type="radio" value="一般"
                                                      v-model="deliveryTime">
                <p><span></span></p><span class="input-text">一般</span></label>
              <label class="input-label-other"><input class="input-radio" type="radio" value="不满意"
                                                      v-model="deliveryTime">
                <p><span></span></p><span class="input-text">不满意</span></label>
            </div>
          </div>
          <div style="width: 100%;margin-top:10px">
            <div class="left-des">商务经理服务</div>
            <div class="right-content">
              <label class="input-label-first"><input class="input-radio" type="radio" value="满意"
                                                      v-model="managerService">
                <p><span></span></p><span class="input-text">满意</span></label>
              <label class="input-label-other"><input class="input-radio" type="radio" value="一般"
                                                      v-model="managerService">
                <p><span></span></p><span class="input-text">一般</span></label>
              <label class="input-label-other"><input class="input-radio" type="radio" value="不满意"
                                                      v-model="managerService">
                <p><span></span></p><span class="input-text">不满意</span></label>
            </div>
          </div>
          <div style="width: 100%;margin-top:25px">
            <div class="left-des"><span style="font-weight: 600;color: #1D1D28;">我想说</span>(选填)</div>
            <div style="float:right;width:70px;right:36px;position: relative;">
              {{textareaValue.length}}/200
            </div>
          </div>
          <div style="width: 92%;margin-top:6px;margin-left:37px">
            <v-textarea
                solo
                background-color="#F5F5F6"
                v-model="textareaValue"
                label="请告诉我们您最真实的想法…"
                :maxlength="200"
            ></v-textarea>
          </div>
          <div style="float:right;width:70px;right:45px;position: relative;margin-top:-20px">
            <input class='input-check' type="checkbox" value="0" v-model="isAnonymous"><span
              class='input-span'>匿名</span>
          </div>
          <div class="submit-but" @click="submitEvaluation">
            提交评价
          </div>
        </div>
      </div>
      <div class="orderDetailCtn" style="height:350px;" v-if="evaluationSuccess == 1">
        <div class="orderAppraiseTitle">
          订单评价
        </div>
        <div style="margin-left:38px">
                <div class="evaluationSuccessContent1">
                  感谢您的支持！
                </div>
                <div class="evaluationSuccessContent2">
                  我们已获悉您对本次服务的评价。我们十分重视您的意见和建议并会不断提升完善产品质量和服务水平，期待再次为您服务！
                </div>
                <!--<button class="evaluationSuccessbutton1" @click="toOther(0)">去逛星空大本营</button>-->
                <button class="evaluationSuccessbutton2" @click="toOther(1)">查看我的套件</button>

              </div>
      </div>
      <div class="bottomTip">
        若您有任何疑问请咨询商务经理：0431-86008580
      </div>

    </div>

  </div>

</template>

<script>
import $ from "jquery";
export default {
  name: "rsOrderAppraise",
  data(){
    return{
      orderId:'',
      progressStat:2,
      orderDetail:{},
      orderListItem:{
        items:[{
          orderName:'订单名称1',
          orderNumber:'20170101090013123001',
          orderTime:'2022-01-17 15:27:39'
        }
        ]
      },
      showTypeList:false,
      chooseTypeName:'全部类型',
      searchInput:'',
      //评价栏
      rating:0,  //总体满意度
      productQuality:'',  //产品质量
      deliveryTime:'', //交付时效
      managerService:'',  //商务经理服务
      textareaValue: '',
      isAnonymous:false,
      isNotAlreadEvaluate:true,   //是否没有评价
      evaluationSuccess:0
    }
  },
  methods:{
    //获取评价状态
    getEvaluation:function () {
      this.axios.get('/tilesapi/tiles/county/evaluate/queryEvaluateInfoByOrderId?orderId='+this.orderId,
          {headers: {Authorization: "Bearer " + localStorage.getItem("token")}}
      ).then((res) => {
        console.log(res)
        let response=res.data.data;
        if(response){
          if(response.createTime){
            this.textareaValue=response.evaluateDetail;
            this.managerService=response.managerScore;
            this.deliveryTime=response.postScore;
            this.productQuality=response.productScore;
            this.rating=response.overallScore;
          }
        }
      })
    },
    //提交评价
    submitEvaluation:function(){
      let that = this;
      if(this.rating == 0 || this.productQuality =='' || this.deliveryTime =='' || this.managerService ==''){
        $(".alert-show").css({ display:'block',position:'fixed', top: 80 });
        alert("请填写必填信息")
        return
      }
      let isAnonymousToBack;
      if(that.isAnonymous){
        isAnonymousToBack = 1;
      }else{
        isAnonymousToBack = 0;
      }
      // let param = new FormData()  // 创建form对象
      // param.append('orderId', that.orderId)  // 通过append向form对象添加数据
      // param.append('overallScore',that.rating.toString())  // 通过append向form对象添加数据
      // param.append('dataProductScore', that.productQuality)  // 通过append向form对象添加数据
      // param.append('submitTimeScore', that.deliveryTime)  // 通过append向form对象添加数据
      // param.append('managerScore', that.managerService)  // 通过append向form对象添加数据
      // param.append('evaluteDetail', that.textareaValue)  // 通过append向form对象添加数据
      // param.append('isAnonymous', isAnonymousToBack)  // 通过append向form对象添加数据
      that.axios.post("/tilesapi/tiles/county/evaluate/add",
          {
            "orderId": that.orderId,
            "overallScore": that.rating, //星星个数:1,2,3,4,5
            "productScore": that.productQuality, //数据产品质量：满意/一般/不满意
            "postScore": that.deliveryTime,//满意/一般/不满意
            "managerScore": that.managerService,//满意/一般/不满意
            "evaluateDetail": that.textareaValue,//详情
            "anonymousStatus": isAnonymousToBack, //0实名1匿名
          },
          {headers: {Authorization: "Bearer " + localStorage.getItem("token")}}
      ).then((res) => {
        console.log(res)
        if(res.data.msg == "操作成功"){
          this.evaluationSuccess = 1;
          this.progressStat=5;
        }
      })
    },
    //去往星空大本营、继续选购数据
    toOther(value){
      if(value == 0){
        this.$router.push("/Forum");
      }else if(value == 1){
        this.$router.push("/MyRSservices");
      }
    },
    getOrderDetail:function () {
      this.axios.get('/tilesapi/tiles/standard/order/queryStandardOrderByOrderId?orderId='+this.orderId,
          {headers: {Authorization: "Bearer " + localStorage.getItem("token")}}
      ).then((res) => {
        console.log(res)
        if(res.data.code==200){
          this.orderDetail=res.data.data;
          let quarters=[];
          for(let i=0;i<this.orderDetail.repCountyList.length;i++){
            quarters.push(this.orderDetail.repCountyList[i].subName)
          }
          this.orderDetail.quarters=quarters;
          //确定是否已评价
          if(this.orderDetail.evaluateStatus=='已评价'){
            this.isNotAlreadEvaluate=false
          }
          else {
            this.isNotAlreadEvaluate=true
          }
          switch (this.orderDetail.status) {
            case '订单提交':
              this.progressStat=2;
              break;
            case '待确认':
              this.progressStat=3;
              break;
            case '已确认':
              this.progressStat=3;
              break;
            case '已驳回':
              this.progressStat=3;
              break;
            case '已取消':
              this.progressStat=3;
              break;
            case '已交付':
              if(this.orderDetail.evaluateStatus=='未评价'){
                this.progressStat=4;
              }
              else if(this.orderDetail.evaluateStatus=='已评价'){
                this.progressStat=5;
              }
              break;
            default:
              break;
          }
        }
      })
    },
  },
  mounted() {
    this.orderId=this.$route.params.orderId;
    console.log(this.orderId);
    this.getOrderDetail();
    this.getEvaluation();
    document.addEventListener("click",this.closeChooseType)

  }
}
</script>

<style scoped lang="scss">
.orderAppraiseTitle{
  width: 100%;
  height:54px;
  line-height: 54px;
  color:#ffffff;
  text-align: center;
  font-size:16px;
  background: rgba(0,102,204,0.5);
  border-radius: 16px 16px 0px 0px;
  margin-bottom: 20px;
}
::v-deep .v-dialog {
  overflow-y: inherit;
}
.left-des{
  width: 86px;
  display: inline-block;
  position: relative;
  left: 37px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #3A3A3A;
  line-height: 20px;
}
.right-content{
  width: calc(100% - 86px);
  left:65px;
  position: relative;
  display: inline-block;
}
.input-label-first{
  margin-left: 10px;
  position: relative;
}
.input-label-other{
  margin-left: 40px;
  position: relative;

}
.input-radio{
  width: 16px;
  height: 16px;
  top:3px;
  position: relative;
  border: 1px solid #336699;
}
.right-content {
  label{
    position: relative;
    p{
      position: absolute;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      display: block;
      top: 4px;
      left: 0;
    }
  }
}
/*改变选中时的圆点*/
.right-content input:checked+p{
  background-color: #fff;
  border: 1px solid #336699;
  span{
    position: absolute;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #336699;
    left: 2px;
    top:2px;
  }
}
.input-text{
  margin-left: 10px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #3A3A3A;
  line-height: 20px;
}

::v-deep .v-textarea textarea{
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #3A3A3A;
  line-height: 20px;
}
::v-deep .v-textarea .v-label{
  margin-top:-7px;
  color: #CCCCCC;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
}
.input-check{
  width: 16px;
  height: 16px;
  border: 1px solid #979797;
}
.input-span{
  margin-left:10px;
  position: relative;
  top:-3px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #4A4A4A;
  line-height: 20px;
}
.submit-but{
  width: 150px;
  height: 40px;
  position: relative;
  left:calc(50% - 75px);
  top:35px;
  background: #336699;
  border-radius: 6px;
  text-align: center;
  line-height: 40px;
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #FFFFFF;
  bottom: 100px;
  cursor:pointer;
}
.alert-show{
  width: 800px;
  height: 50px;
  background: #FF6666;
  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.5);
  border-radius: 4px;
  left:calc(50% - 400px);
  text-align: center;
  line-height: 50px;
  display: none;

}
.alert-show-text{
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  text-shadow: 0px 0px 3px rgba(0, 0, 0, 0.5);

}
.evaluationSuccess{
  position: relative;
  top:92px;
  width: 1280px;
  height: 350px;
  border-radius: 6px;
  border: 1px solid #B8B8B8;
}
.evaluationSuccessTitle{
  position: relative;
  height: 54px;
  background: #F5F5F6;
  border-radius: 6px 6px 0px 0px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #1D1D28;
  line-height: 54px;
}
.evaluationSuccessContent1{
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #3A3A3A;
  line-height: 22px;
  position: relative;
  top:38px;
}
.evaluationSuccessContent2{
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #3A3A3A;
  line-height: 20px;
  position: relative;
  top:50px;
}
.evaluationSuccessbutton1{
  width: 150px;
  height: 40px;
  background: #336699;
  border-radius: 6px;
  position: relative;
  top:150px;
  left:460px;
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #FFFFFF;
  line-height: 20px;
}
.evaluationSuccessbutton2{
  width: 150px;
  height: 44px;
  background: #0066CC;
  border-radius: 8px;
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  line-height: 20px;
  position: relative;
  top:120px;
  left:480px;
  margin-left: 50px;
}
.orderAppraiseCtn{
  margin-top: 100px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 100px;
  width: 1280px;
  height: 480px;
  border-left: 1px solid #B8B8B8;
  border-right: 1px solid #B8B8B8;
  border-bottom: 1px solid #B8B8B8;
  border-top:1px solid #B8B8B8;
  border-radius: 0px 0px 6px 6px;
}
.orderSubjectOperation{
  width: 112px;
  height: 32px;
  border-radius: 6px;
  line-height: 32px;
  text-align: center;
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 10px;
}
.orderSubjectTxt{
  width: 100%;
  height: 28px;
  line-height: 28px;
  text-align: center;
  font-size: 14px;
}
.subjectInformationFlex{
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}
.subjectImgContainer{
  display: flex;
  flex-wrap:wrap;
  justify-content: flex-start;
  align-items: flex-start;
  padding-top: 20px;
  padding-left: 13px;
  padding-right: 17px;
}
.subjectContainer{
  position:relative;
  box-sizing: border-box;
  background-color: white;
  height: auto;
  min-height: 200px;
  margin-left: 2px;
}
.titleItem{
  float: left;
  height: 54px;
  line-height: 54px;
  font-size: 14px;
}
.orderListItemContainer .title{
  width: 100%;
  height:54px;
}
.orderListItemContainer{
  position:relative;
  width: 100%;
  height: auto;
  background: #F5F5F6;
  border:solid 1px #B8B8B8;
  border-radius: 6px 6px 0px 0px;
  padding: 0px;
}
.orderListContainer{
  margin-top: 20px;
  margin-left: auto;
  margin-right: auto;
  width: 1280px;
  height: auto;
}
/*分割线基础样式*/
.splitLine{
  box-sizing: border-box;
  height: 1px;
  border-bottom: 1px solid #B8B8B8;
}
.typeMenuListItem{
  width: 100%;
  height: 32px;
  line-height: 32px;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  color: #3A3A3A;
}
.typeMenuListItem:hover{
  background-color: #EAEAEA;
}
.typeMenuList{
  position:absolute;
  top:31px;
  left:-1px;
  width: 139px;
  height: auto;
  border-radius: 0px 0px 4px 4px;
  border-left:1px solid #979797;
  border-right:1px solid #979797;
  border-bottom:1px solid #979797;
  background: #ffffff;
}
.typeMenuShow{
  position:relative;
  margin-top: 27px;
  margin-bottom: 27px;
  width: 139px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  border-radius: 4px 4px 0px 0px;
  border-left: 1px solid #979797;
  border-top: 1px solid #979797;
  border-right:1px solid #979797;
  /*border: 1px solid #979797;*/
  font-size: 14px;
  font-weight: 400;
  color: #3A3A3A;
  cursor: pointer;
}
.typeMenu{
  position:relative;
  margin-top: 27px;
  margin-bottom: 27px;
  width: 139px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  border-radius: 4px;
  border: 1px solid #979797;
  font-size: 14px;
  font-weight: 400;
  color: #3A3A3A;
  cursor: pointer;
}
.searchDiv input{
  box-sizing: border-box;
  padding-left: 10px;
  outline: none;
  width:260px;
  height:31px;
  font-size: 14px;
}
.searchDiv{
  /*display: inline-block;*/
  position:absolute;
  top:0px;
  right: 0px;
  width: 300px;
  height: 32px;
  border-radius: 6px;
  border: 1px solid #B8B8B8;
  margin-top: 14px;
}
.myOrderBody {
  position: absolute;
  top: 65px;
  left: 0px;
  width: 100%;
  /*height: calc(100% - 50px);*/
  /*overflow-y: auto;*/
}
.myOrderTitle {
  margin-top: 20px;
  margin-left: auto;
  margin-right: auto;
  width: 1280px;
  height: 54px;
  line-height: 54px;
  padding-left: 43px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight:bold;
  color: #1D1D28;
  background: #F5F5F6;
  border-radius: 6px;
}
.topNav{
  position:relative;
  margin-left: auto;
  margin-right: auto;
  width: 1280px;
  height: 60px;
  border-bottom: 1px solid #CCCCCC;
}
.topNavItem{
  display: inline-block;
  height: 60px;
  line-height: 60px;
  text-align: center;
  width:150px;
  cursor: pointer;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-size: 16px;
  font-weight: bold;
}
.topNavItemChoosed{
  border-bottom: 2px solid #336699 ;
  color: #336699;
}
.orderDetailCtn{
  width: 1280px;
  height:auto;
  background: #FFFFFF;
  border-radius: 16px;
  padding-top: 1px;

}
.bottomTip{
  margin-top: 80px;
  margin-bottom: 80px;
  height:25px;
  line-height: 25px;
  text-align: center;
  font-size: 14px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #3A3A3A;
}
.mainCtn{
  width: 1280px;
  min-height: 300px;
  height: auto;
  margin-left: auto;
  margin-right: auto;
  .title{
    margin-top: 126px;
    position:relative;
    width: 100%;
    height: 45px;
    line-height: 45px;
    font-size: 30px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #3A3A3A;
    text-align: center;
  }
}
.progressButton {
  width: 150px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.progressCircle_Text_time {
  width: 100%;
  text-align: center;
  height: 16px;
  line-height: 16px;
  font-weight: 500;
  color: #3A3A3A;
  font-size: 12px;
}

.progressCircle_Text_name {
  width: 100%;
  text-align: center;
  height: 20px;
  line-height: 20px;
  font-weight: 400;
  color: #3A3A3A;
  font-size: 16px;
}

.progressCircle_Text {
  position: absolute;
  top: 38px;
  left: -30px;
  width: 100px;
  height: auto;
}

.progressCircle_blue {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 28px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  background: #0066CC;
  border-radius: 50%;
}
.progressCircle_red {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 28px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  background: #FF4040;
  border-radius: 50%;
  font-size: 18px;
  color:#ffffff;
}

.progressLine_blue {
  z-index: 2;
  position: relative;
  left: -2px;
  top: 1px;
  width: 186px;
  height: 4px;
  background: #0066CC;
}

.progressLine_gray {
  position: relative;
  width: 182px;
  height: 6px;
  background: #CCCCCC;
  float: left;
  margin-top: 14px;
  margin-left: -1px;
}

.progressCircle_gray {
  position: relative;
  width: 32px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  border-radius: 50%;
  background: #CCCCCC;
  float: left;
  margin-left: -1px;
  font-weight: 900;
  color: #FFFFFF;
}

.progressBar {
  position: relative;
  width: 100%;
  height: 45px;
}

.progressBarCtn {
  width: 883px;
  height: 107px;
  margin-top: 30px;
  margin-left: auto;
  margin-right: auto;
}
</style>
